import React from "react";
import styles from "./DisclaimerId.module.less";
const DisclaimerId = ({ value }) => {
    if (value == null || !value.length) {
        return null;
    }
    return (<sup className={styles.disclaimerId}>
			[{value.map((disc, index) => (<span key={index}>
				{index > 0 && ", "}
				<a href={`#Disclaimer${disc}`} id={`DisclaimerLink${disc}`} onClick={(e) => {
        e.preventDefault();
        document.getElementById(`Disclaimer${disc}`).focus();
        document.getElementById(`Disclaimer${disc}`).scrollIntoView();
    }}>
					{disc}
				</a>
			</span>))}]
		</sup>);
};
export default DisclaimerId;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/AccountList/AccountCard/DisclaimerId/DisclaimerId.tsx